import React from "react";

import { ArticleEntityLinkEntity } from "@/mk2/apps/wiki/schemas";
import { WIKI_ARTICLE_REVIEWED_BY } from "@/mk/autogenerated/translation";

import styles from "./ReviewerAttribution.mscss";

interface Props {
    entityLinks?: ArticleEntityLinkEntity[];
}

// Temporarily disabled until the reviewer relation is backfilled
// (`migrate_reviewer_attribution`) and the now-duplicated free-text blocks are
// removed from article bodies. Until then, rendering this would show the
// attribution twice. Flip to `true` to enable the visible block.
// (Typed as boolean so the code below stays reachable / type-checked.)
const REVIEWER_ATTRIBUTION_ENABLED: boolean = false;

// Renders the "Text po odbornej stránke skontroloval(a): …" block at the end of a
// wiki article. Single source of truth: the reviewer WikiEntity(person) links
// (role="reviewer"), the same relation that feeds the JSON-LD `reviewedBy` node.
export const ReviewerAttribution: React.FC<Props> = ({ entityLinks }) => {
    if (!REVIEWER_ATTRIBUTION_ENABLED) return null;

    const reviewers = (entityLinks ?? []).filter((link) => link.role === "reviewer");
    if (!reviewers.length) return null;

    return (
        <div className={styles.ReviewerAttribution}>
            <div className={styles.ReviewerAttribution__label}>{WIKI_ARTICLE_REVIEWED_BY}</div>
            {reviewers.map((link) => (
                <div key={link.id} className={styles.ReviewerAttribution__reviewer}>
                    <div className={styles.ReviewerAttribution__name}>{link.entity.name}</div>
                    {link.entity.jobTitle && (
                        <div className={styles.ReviewerAttribution__detail}>
                            {link.entity.jobTitle}
                        </div>
                    )}
                    {link.entity.affiliation && (
                        <div className={styles.ReviewerAttribution__detail}>
                            {link.entity.affiliationUrl ? (
                                <a
                                    href={link.entity.affiliationUrl}
                                    className={styles.ReviewerAttribution__link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {link.entity.affiliation}
                                </a>
                            ) : (
                                link.entity.affiliation
                            )}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};
